module.exports = __webpack_public_path__ + "static/boardroom-85bb49bff6c0510ecd94b3a1150c2e1b.jpg";